import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  templateUrl: './error-popin.component.html'
})
export class NeqErrorPopinComponent implements OnInit {

  message: string;
  errorDetails?: string[] = [];

  constructor(
    private readonly dialogRef: MatDialogRef<NeqErrorPopinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {message: string, errorDetails: string[]}
) {
  }

  ngOnInit() {
    if (this.data) {
      const argMessage = this.data.message;
      const argErrorDetails = this.data.errorDetails;

      if (argMessage) {
        this.message = argMessage;
      }
      if (argErrorDetails) {
        this.errorDetails = argErrorDetails;
      }
    }
  }

  continue() {
    this.dialogRef.close();
  }

}
